/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import { sendMessage } from "@hcecbp/uiintegrationcomponent";

import { ConfigurationVariables } from "../config";

// A failed notification must never turn a completed action into a reported failure.
export const notifyParent = (event: Record<string, unknown>): void => {
  try {
    sendMessage(
      ConfigurationVariables.RBM_PORTAL_HOST_URL,
      {
        type: "appContext",
        payload: { viewType: JSON.stringify(event) },
      },
      window.parent,
    );
  } catch (error) {
    console.error("Failed to notify the parent window", error);
  }
};
